import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { BRAND } from "@/lib/site";
import SEO from "@/components/SEO";
import PageHeader from "@/components/PageHeader";
import QuoteForm from "@/components/QuoteForm";
import MapEmbed from "@/components/MapEmbed";

const POINTS = [
  {
    icon: Phone,
    label: "Phone",
    value: BRAND.phone,
    href: BRAND.phoneTel,
    testId: "contact-phone",
  },
  {
    icon: Mail,
    label: "Email",
    value: BRAND.email,
    href: BRAND.emailHref,
    testId: "contact-email",
  },
  {
    icon: MapPin,
    label: "Service Area",
    value: "Servicing all of Sydney",
    testId: "contact-area",
  },
  {
    icon: Clock,
    label: "Hours",
    value: "24 hours · 7 days",
    testId: "contact-hours",
  },
];

export default function ContactPage() {
  return (
    <>
      <SEO
        title="Contact — Talk to a Real Sydney Plumber Now"
        description={`Contact Flowgrid Plumbing — call ${BRAND.phone} or send a free quote request. We answer 24/7 and usually reply within 15 minutes during business hours.`}
        canonicalPath="/contact"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "ContactPage",
          name: "Contact Flowgrid Plumbing",
          mainEntity: {
            "@type": "Plumber",
            name: BRAND.name,
            telephone: BRAND.phone,
            email: BRAND.email,
          },
        }}
      />
      <PageHeader
        eyebrow="Contact"
        title="Talk to a real plumber, right now."
        subtitle="Call us anytime or send a quote request — we usually reply within 15 minutes during business hours."
      />

      <section className="bg-white py-20 md:py-24" data-testid="contact-section">
        <div className="fg-container grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="grid gap-4">
              {POINTS.map((p) => {
                const Icon = p.icon;
                const Wrapper = p.href ? "a" : "div";
                return (
                  <Wrapper
                    key={p.label}
                    {...(p.href ? { href: p.href } : {})}
                    data-testid={p.testId}
                    className="fg-card-hover flex items-start gap-4 rounded-2xl border border-slate-200 bg-white p-5"
                  >
                    <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-blue-50 text-blue-700">
                      <Icon className="h-5 w-5" />
                    </div>
                    <div>
                      <div className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500">
                        {p.label}
                      </div>
                      <div className="mt-1 font-display text-lg font-bold text-slate-900">
                        {p.value}
                      </div>
                    </div>
                  </Wrapper>
                );
              })}
            </div>

            <div className="mt-6">
              <MapEmbed height={340} />
            </div>
          </div>

          <div className="md:col-span-7">
            <div className="rounded-2xl border border-slate-200 bg-white p-7 shadow-md">
              <div className="text-xs font-bold uppercase tracking-[0.18em] text-blue-700">
                Quote Request
              </div>
              <h2 className="mt-2 font-display text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
                Tell us about the job.
              </h2>
              <p className="mt-3 max-w-md text-base text-slate-600">
                Fill in the form below — we'll call back with an honest, fixed quote.
              </p>
              <div className="mt-7">
                <QuoteForm idPrefix="contact" />
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  );
}
